export class BlobModel {
  content: Blob;
  name: string;
  patientId: string;
}
